import React, { useState, useEffect } from 'react';
import { CircularProgress, Grid, Typography } from '@mui/material';
import { HotGame, getHotGames } from '../../../core/API/hotGames';
import './HotGames.scss';

interface HotGamesProps {
	title?: string;
	onGamesLoaded?: (games: HotGame[]) => void;
}

const HotGames: React.FC<HotGamesProps> = ({ title = 'Mabel A.I. - Hot Games', onGamesLoaded }) => {
	const [games, setGames] = useState<HotGame[]>([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const fetchGames = async () => {
			try {
				const hotGamesData = await getHotGames();
				setGames(hotGamesData);
				if (onGamesLoaded) {
					onGamesLoaded(hotGamesData);
				}
			} catch (error) {
				console.error('Error fetching hot games:', error);
				setGames([]);
			} finally {
				setLoading(false);
			}
		};

		fetchGames();
	}, [onGamesLoaded]);

	return (
		<Grid container direction="column" className="hotGamesCard hot-games-container white-card">
			<Grid item className="hot-games-header">
				<Typography variant="h6" sx={{ py: 2, m: 0, fontWeight: 500, fontSize: '20px' }}>
					{title}
				</Typography>
			</Grid>
			{loading ? (
				<Grid item className="loading-container">
					<CircularProgress size={20} />
				</Grid>
			) : (
				<Grid item className="hot-games-list scrollable">
					{games.map((game) => (
						<Grid
							key={game.id}
							container
							item
							className="hot-game-item"
							direction="column"
							spacing={1}
						>
							<Grid item>
								<Grid container className="game-title">
									{game.teams}
								</Grid>
							</Grid>
							<Grid item>
								<Grid>
									{game.date?.slice(0, 10)} {game.time} {game.timezone}
								</Grid>
							</Grid>
							<Grid item style={{ padding: '0px' }}>
								<Grid
									container
									direction="column"
									className="game-details"
									spacing={1}
									alignItems="flex-start"
								>
									<Grid item className="hot-reason">
										{game.why_hot}
									</Grid>
									<Grid item className="broadcast">
										{game.broadcast}
									</Grid>
									{/* <Grid item className="game-location" style={{ marginLeft: 'auto' }}>
										{game.city}, {game.country}
									</Grid> */}
									<Grid item className="game-location">
										{game.city}, {game.country}
									</Grid>
								</Grid>
							</Grid>
							<Grid item style={{ marginBottom: '5px' }}></Grid>
						</Grid>
					))}
					{games.length === 0 && !loading && (
						<Grid item className="no-games">
							No hot games available
						</Grid>
					)}
				</Grid>
			)}
		</Grid>
	);
};

export default HotGames;
